module.exports = __webpack_public_path__ + "static/media/yes_tick.5ca415ee.png";